import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@monksflow/monks-ui';
import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@/shared/ui/SearchInput';
import type { FolderGuidelinesToolbarProps } from './FolderGuidelinesToolbar.types';

/**
 * Always renders, even with zero guidelines: the empty state moves inside
 * the table instead of hiding this toolbar, unlike the legacy page which
 * swaps the whole body for `EmptyGuidelinesList`.
 */
export function FolderGuidelinesToolbar({
  searchQuery,
  onSearchChange,
  canManage,
  onAddGuideline,
  hasGuidelines,
  isExporting,
  onExport,
}: FolderGuidelinesToolbarProps) {
  const { t } = useTranslation('knowledge');

  const addButton = (
    <Button variant="default" size="lg" onClick={onAddGuideline} disabled={!canManage}>
      {t('guidelines.guidelinesToolbar.addGuideline')}
    </Button>
  );

  return (
    <div className="flex items-center justify-between gap-md">
      <SearchInput
        value={searchQuery}
        onChange={onSearchChange}
        placeholder={t('guidelines.guidelinesToolbar.searchGuideline')}
        aria-label={t('guidelines.guidelinesToolbar.searchGuidelineLabel')}
        clearable
        size="lg"
        className="w-[420px]"
      />
      <div className="flex items-center gap-xs">
        <Button
          variant="outline"
          size="lg"
          onClick={onExport}
          disabled={!hasGuidelines || isExporting}
        >
          <DownloadIcon />
          {t('folderGuidelines.exportGuidelines')}
        </Button>
        {canManage ? (
          addButton
        ) : (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="inline-flex">{addButton}</span>
              </TooltipTrigger>
              <TooltipContent>
                {t('guidelines.guidelinesToolbar.youDonTHavePermission')}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
    </div>
  );
}

FolderGuidelinesToolbar.displayName = 'FolderGuidelinesToolbar';
